module.exports = __webpack_public_path__ + "img/SKTC_SGR.4444ed91.png";